import { Button, Card, CardHeader, TextField } from '@material-ui/core';
import React, { Component } from 'react';

import { connect } from 'react-redux';
import { register } from '../../redux/actions';
import { setError, setSuccess } from '../../redux/actions/MessageAction';
import { baseStyles } from '../../theme/style';
import Alerts from '../common/Alerts';
import MyLink from '../common/MyLink';
import { Loading } from '../common';

class Register extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userName: '',
      fName: '',
      lName: '',
      email: '',
      password: '',
      isLoading: false,
    };
    this.updateIsLoading = this.updateIsLoading.bind(this);
  }

  onChange = ({ name, value }) => {
    this.setState({ [name]: value });
    this.props.setSuccess('');
    this.props.setError('');
  };
  updateIsLoading = (isLoading) => {
    this.setState({ isLoading });
  };

  handleSignup() {
    const { fName, lName, userName, email, password } = this.state;
    this.props.register({ fName, lName, userName, email, password }, this.updateIsLoading);
  }

  render() {
    console.log('register=>');
    console.log(this.props.user);
    if (this.props.user.register) {
      this.props.history && this.props.history.push('');
    }

    let content = (
      <Card style={baseStyles.loginBox}>
        <span>Thank you for signing up! An email has been sent to you to verify your account.</span>
      </Card>
    );

    content = (
      <div style={baseStyles.container}>
        <Card style={baseStyles.loginBox}>
          <CardHeader title="Sign Up" />
          <div style={baseStyles.form}>
            <TextField
              placeholder="Username"
              name="userName"
              fullWidth={true}
              onChange={(e) => this.onChange(e.target)}
              value={this.state.userName}
            />
            <TextField placeholder="First Name" name="fName" fullWidth={true} onChange={(e) => this.onChange(e.target)} value={this.state.fName} />

            <TextField placeholder="Last Name" name="lName" fullWidth={true} onChange={(e) => this.onChange(e.target)} value={this.state.lName} />

            <TextField placeholder="Email" name="email" fullWidth={true} onChange={(e) => this.onChange(e.target)} value={this.state.email} />
            <TextField
              placeholder="Password"
              name="password"
              fullWidth={true}
              onChange={(e) => this.onChange(e.target)}
              value={this.state.password}
              type="password"
            />

            <Button variant="contained" color="primary" onClick={this.handleSignup.bind(this)}>
              Register
            </Button>

            <Alerts />
          </div>
          <div style={baseStyles.link}>
            <MyLink pathname={'/'}>To Login</MyLink>
          </div>
          {this.state.isLoading && <Loading />}
        </Card>
      </div>
    );

    return <div>{content}</div>;
  }
}

const styles = {
  error: {
    fontWeight: 'bold',
    color: '#f7183a',
  },
  success: {
    color: '#4CAF50',
  },
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    error: state.message.error,
    success: state.message.success,
  };
};

const mapDispatchToProps = {
  register,
  setError,
  setSuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
